export const DAY_FORMAT = "dd MMM yyyy"

export const DATE_TIME_FORMAT = "dd MMM yyyy, hh:mm a"
